import React from 'react'
import userAvatar from '../../assets/user-icon-white2.png'
import consultantAvatar from '../../assets/AI-icon-white.png'

export default function ChatMessage({message}) {
    return (
      <div className={`chat-message ${message.user == "assistant" && "gpt"}`}>
        <div className={`chat-message-center ${message.user == "assistant" && "gpt"}`}>
          {message.user == "user" && <div className="avatar"><img src={userAvatar} alt="avatar" width="100%" height="100%"/></div>}
          <div className={`message ${message.user == "assistant" && "gpt"}`}> {message.message} </div>
          {message.user == "assistant" && <div className="avatar gpt"><img src={consultantAvatar} alt="avatar" width="100%" height="100%"/></div>}
        </div>
      </div>
    )
  }